import { render, staticRenderFns } from "./WriterProfile.vue?vue&type=template&id=6b91476c&scoped=true&"
import script from "./WriterProfile.vue?vue&type=script&lang=js&"
export * from "./WriterProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b91476c",
  null
  
)

export default component.exports